import { useCallback } from 'react'
import { requests } from '../../../core/ajax'

export const useCollaboratorsCalls = () => {
  const { get } = requests

  const getCollaborators = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        get('/instalador/tabla_colaboradores', config)
          .then((response) => {
            return resolve(response)
          })
          .catch(({ response }) => {
            return reject(response)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return {
    getCollaborators,
  }
}
